import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import b from 'b_';
import FlagStore from '../../stores/FlagStore';
import BoolStore from '../../stores/helpers/BoolStore';
import { FTLabel } from '../Fuse';
import FuseInfoTooltip from './FuseTooltip/FuseInfoTooltip';
import './FuseSwitch.css';

const block = b.lock('FuseSwitch');

class FuseSwitch extends Component {
    static propTypes = {
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        focus: PropTypes.bool,
        hover: PropTypes.bool,
        active: PropTypes.bool,
        headerInfoPosition: PropTypes.string,
        store: PropTypes.oneOfType([FlagStore.PropType.isRequired, BoolStore.PropTypes.isRequired]),
        label: PropTypes.string,
        header: PropTypes.node,
        headerInfo: PropTypes.string,
        onToggleChange: PropTypes.func,
        qa: PropTypes.string
    };

    state = {
        focus: false,
    };

    onClick = (e) => {
        if (e.pageX !== 0 && e.pageY !== 0) {
            this.setState({ focus: false });
        }
    };

    onChange = () => {
        const { store } = this.props;
        store.toggle();
        if (this.props.onToggleChange) {
            this.props.onToggleChange(store.getValue());
        }
    };

    render() {
        const {
            store,
            label,
            className,
            readOnly,
            disabled,
            focus,
            hover,
            active,
            header,
            headerInfo,
            headerInfoPosition,
            onToggleChange,//eslint-disable-line
            qa,
            ...inputProps
        } = this.props;

        return <div className={className}>
            <label
                className={cn(block({
                    checked: store.getValue(),
                    disabled: readOnly || disabled,
                    hover: hover === true,
                    active: active === true,
                    focused: focus === undefined ? this.state.focus : focus,
                }))}
                {...qa ? { 'data-qa': qa } : {}}
            >
                {header ? <div className={block('Header')}>
                    <FTLabel>{header}</FTLabel>
                    {headerInfo ? <FuseInfoTooltip position={headerInfoPosition}>{headerInfo}</FuseInfoTooltip> : null}
                </div> : null}

                <div className={block('SwitchContainer')}>
                    <input
                        className={block('Input')}
                        type="checkbox"
                        disabled={readOnly || disabled}
                        checked={store.getValue()}
                        onChange={this.onChange}
                        onClick={this.onClick}
                        onFocus={() => this.setState({ focus: true })}
                        onBlur={() => this.setState({ focus: false })}
                        {...qa ? { 'data-qa': `${qa}-input` } : {}}
                        {...inputProps}
                    />
                    <div className={block('Track')}>
                        <div className={block('ThumbUnderlay')} />
                    </div>
                    <div className={block('Text', { disabled, readOnly })}>{label}</div>
                </div>
            </label>
        </div>;
    }
}

export default observer(FuseSwitch);
